export default __webpack_public_path__ + "static/media/trophy.bf289289.svg";